import React from "react";
import { formatToPhone } from "../../../utils/formatToPhone";

const PhoneInputMask: React.FC<{
  placeholder: string;
  name: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  onInputBlur: (e: React.FocusEvent<HTMLInputElement>) => void;
  onInputFocus?: (e: React.FocusEvent<HTMLInputElement>) => void;
  value: string;
  [key: string]: any;
}> = ({
  placeholder,
  name,
  onChange,
  className,
  onInputBlur,
  onInputFocus,
  value,
  ...rest
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const numberValue = e.target.value
      .replace(/\D/g, "")
      .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);

    const numbers = numberValue[0];

    onChange({
      ...e,
      target: { ...e.target, type: "text", name: name, value: numbers },
    });
  };

  return (
    <input
      type="text"
      placeholder="(___) ___-____"
      max={10}
      name="phone_number"
      onChange={handleChange}
      onBlur={onInputBlur}
      onFocus={onInputFocus}
      className={className}
      value={formatToPhone(value)}
      {...rest}
    />
  );
};

export default PhoneInputMask;
